import { jwtDecode } from 'jwt-decode';

const getRolesFromToken = (accessToken: string): string[] => {
  try {
    const decoded: { roles?: string[] } = jwtDecode(accessToken);
    return decoded.roles || [];
  } catch (error) {
    throw new Error(`Failed to decode JWT token: ${error}`);
  }
};

export default getRolesFromToken;
